import { useQuery } from '@tanstack/react-query';

import { health } from '../api/client';

type ChipState = 'up' | 'down' | 'unknown';

function Chip({ label, state }: { label: string; state: ChipState }) {
  return (
    <span className={`chip chip--${state}`} title={`${label}: ${state}`}>
      <span className="chip__dot" aria-hidden="true" />
      {label}
    </span>
  );
}

/** Live API / Postgres / Redis status from GET /healthz. */
export function ApiStatusChips() {
  const { data, isError, isPending } = useQuery({
    queryKey: ['health'],
    queryFn: ({ signal }) => health.get(signal),
    refetchInterval: 15_000,
    retry: 0,
  });

  const apiState: ChipState = isPending ? 'unknown' : isError ? 'down' : 'up';
  const dbState: ChipState = data ? data.db : isError ? 'down' : 'unknown';
  const redisState: ChipState = data ? data.redis : isError ? 'down' : 'unknown';

  return (
    <div className="status-chips" role="status" aria-label="Backend status" data-testid="health-chips">
      <Chip label="API" state={apiState} />
      <Chip label="DB" state={dbState} />
      <Chip label="Redis" state={redisState} />
    </div>
  );
}
